module.exports = ":host { \r\n    min-height: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n}"